import ar from "./ar";
import en from "./en";

/*
 * contact-uae translations live outside the shared dictionary so only this
 * feature's pages download them.
 */
export const contactUaeTextByLocale = { ar, en };

export function getContactUaeText(locale) {
  return contactUaeTextByLocale[locale] ?? contactUaeTextByLocale.ar;
}
